import React from "react";
import {
  Form,
  Row,
  Col,
  Input,
  message,
  Button,
  Space,
  Tooltip,
  Modal,
  Upload,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";

import { CloseOutlined } from "@ant-design/icons";

import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";

import ListTable from "./ListTable";

import VehicleMaintenanceStore from "../store/VehicleMaintenanceStore";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import VehicleMaintenanceAdd from "./VehicleMaintenanceAdd";
import MaintenanceListFields from "./Plugins/AddMaintenance/MaintenanceListFields";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";

import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg";
const { Dragger } = Upload;

class VehicleMaintenanceList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.maitenanceStore = new VehicleMaintenanceStore();
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      offset: 0,
      limit: 50,
      companyId: "",
      loadData: 0,
      openConfirm: false,
      confirmLoading: false,
      company_value_label: "",
      searchField: "",
      searchFieldDate: "",
      openVehicleMaintenanceForm: false,
      vehicleMaintenanceId: "",
      listDataUpdate: false,
      companyFieldHighlight: false,
      excelCompanyId: "",

      openDeleteModal: false,
      deleteData: {},
    };
    this.columns = [
      {
        // title: " Vehicle No",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("vehiclemaintenancelist") &&
                  this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        // title: "Driver Name",
        title: context.translate("_DRIVER_NAME_"),
        dataIndex: "name",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Current Odometer ",
        title: context.translate("_CURRENT_ODOMETER_"),
        dataIndex: "currentOdometer",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: " Garage Name",
        title: context.translate("_GARAGE_NAME_"),
        dataIndex: "garageName",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Service Date",
        title: context.translate("_SERVICE_DATE_"),
        dataIndex: "serviceDate",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      // {
      //   // title: "Service Type ",
      //   title:context.translate("_SERVICE_TYPE_"),
      //   dataIndex: "serviceName",
      //   width: "20%",
      // },
      {
        // title: " Garage Address ",
        title: context.translate("_GARAGE_ADDRESS_"),
        dataIndex: "garageAddress",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "  Amount ",
        title: context.translate("_AMOUNT_"),
        dataIndex: "totalAmmount",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed: 'right',
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    // title="Edit Maintenance"
                    title={context.translate("_EDIT_MAINTENANCE_")}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete Maintenance"
                      title={context.translate("_DELETE_MAINTENANCE_")}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}
                {/* <Tooltip
                  title={context.translate("_EDIT_MAINTENANCE_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={editIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      await this.onEdit(record);
                    }}
                  ></Image>
                </Tooltip> */}

                {this.props.canUpdate("vehiclemaintenancelist") && (
                  <Tooltip
                    title={context.translate("_EDIT_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}

                {this.props.canDelete("vehiclemaintenancelist") && (
                  <Tooltip
                    title={context.translate("_DELETE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const beforeEditCompanyId =
        this.context.viewStateStore.VehicleMaintenanceObject.companyId;
      await this.maitenanceStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: beforeEditCompanyId,
        searchField: this.state.searchField,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        this.context.viewStateStore.VehicleMaintenanceObject.companyId
      );
      await this.setState({ listUpdated: 1 }); //need to reload data
      await this.setState({
        company_value_label: singleData,
        companyId: beforeEditCompanyId,
      });
      this.setState({ listDataUpdate: false });
    }
  }

  async componentDidMount() {
    // await this.maitenanceStore.loadData({ offset: 0, limit: 50 });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        excelCompanyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.maitenanceStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      searchFieldDate: this.state.searchFieldDate,
    });
    await this.setState({ loadData: 1 });
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setVehicleMaintenanceStates({
      companyId: record.companyId,
    });
    this.setState({ vehicleMaintenanceId: record.Id });
    this.setState({ openVehicleMaintenanceForm: true });
    // await this.props.navigate("/vehiclemaintenanceadd/" + record.Id);
  };

  async onDelete(record) {
    const response = await this.maitenanceStore.deleteRecord({
      Id: record.Id,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  searchInput = async (e) => {
    const value = e.target.value;
    if (value.length > 2 || value.length === 0) {
      await this.maitenanceStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        searchFieldDate: this.state.searchFieldDate,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 0 });
    }
  };

  async searchInputButton() {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.maitenanceStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        searchFieldDate: this.state.searchFieldDate,
        companyId: this.state.companyId,
      });
      await this.setState({ loadData: 1 });
    }
  }

  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      this.setState({ openVehicleMaintenanceForm: false });
      this.setState({ listDataUpdate: true });
      //  this.props.navigate("/vehiclemaintenancelist");
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(["This Service Type already exists"]);
      });
    }
  };

  closeModal = () => {
    this.setState({
      openVehicleMaintenanceForm: false,
      vehicleMaintenanceId: "",
    });
  };

  getUploadData = async (fileUp) => {
    console.log(fileUp);
    let fileinfo = fileUp.file.response;

    console.log(fileinfo);

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  onExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.excelCompanyId,
      excelFile: this.state.excelFile,
    };

    if (data.excelFile) {
      const resp = await this.maitenanceStore.addVehMainByExcel(data);

      if (resp?.success == "S") {
        console.log(resp.data.length > 0);
        message.success(resp.message);

        this.setState({ showUpload: false });
        this.setState({ excelFile: "" });
        this.handleSearch();
        // this.formRef.current?.resetFields();
      } else {
        message.error(resp.message);
      }
      if (resp.message) {
        this.setState({ showUpload: false });
        // this.formRef.current?.resetFields();
      }
    } else {
      message.error("Please Upload Excel File");
    }
  };

  handleUploadClick = () => {
    this.setState({ showUpload: true });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.maitenanceStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        searchField: "",
      });
    }
    this.setState({ loading: false, searchField: "", currentPage: 1 });
  };
  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  //  allowClear={true}
                  onChange={(value) => this.handleChange(value)}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  // style={{ width: 200 }}
                  style={companyInputBox}
                />
                <Input
                  // placeholder="Search by Garage,Service Type,Vehicle"
                  placeholder={this.context.translate(
                    "_SEARCH_BY_GARAGE_SERVICE_VEHICLE_"
                  )}
                  value={this.state.searchField ? this.state.searchField : ""}
                  style={{ width: 400, borderRadius: "25px" }}
                  onKeyUp={(e) => this.searchInput(e)}
                  onChange={(e) => {
                    this.setState({ searchField: e.target.value });
                  }}
                />

                {/* <DatePicker
                  style={{ width: "160px" }}
                  // placeholder="Search By Date"
                  placeholder={this.context.translate("_SEARCH_DATE_")}
                  allowClear
                  onChange={async (val) => {
                    if (val === null) {
                      await this.setState({ searchFieldDate: "" });
                      await this.handleSearch();
                    } else {
                      await this.setState({
                        searchFieldDate: val.format("YYYY-MM-DD"),
                      });
                      await this.handleSearch();
                    }
                  }}
                /> */}
                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.searchInputButton();
                  }}
                /> */}
              </Space>
            </Col>
            <Col span={8}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <MaintenanceListFields
                  handleUploadClick={this.handleUploadClick}
                />

                {this.props.canCreate("vehiclemaintenancelist") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({
                        openVehicleMaintenanceForm: true,
                        vehicleMaintenanceId: "",
                      })
                    }
                  >
                    <Image
                      style={{
                        marginInlineEnd: "5px",
                        width: 13,
                      }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>

                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.maitenanceStore?.total}
            columns={this.columns}
            dataSource={this.maitenanceStore?.maintainVehicles}
            loading={this.maitenanceStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openVehicleMaintenanceForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openVehicleMaintenanceForm}
            placement={
              this.context.locale.language === "english" ? "right" : "left"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ADD_MAINTENANCE_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_MAINTENANCE_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openVehicleMaintenanceForm: false })}
            onCancel={() =>
              this.setState({ openVehicleMaintenanceForm: false, userId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleMaintenanceAdd
                vehicleMaintenanceId={this.state.vehicleMaintenanceId}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {/* {this.state.showUpload && (
          <>
            {" "}
            <Modal
              open={this.state.showUpload}
              // title="File Upload"
              title={this.context.translate("_FILE_UPLOAD_")}
              maskClosable={false}
              onOk={() => this.setState({ showUpload: false })}
              onCancel={() =>
                this.setState({
                  showUpload: false,
                  excelFile: "",
                  companyId: "",
                })
              }
              footer={false}
              width={400}
              // style={{width:100}}
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelSubmit}
                style={{ padding: "0px 10px" }}
              >
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                  <Form.Item
                    name="companyId"
                    label={this.context.translate("_ACCOUNT_")}
                    rules={[{ required: true }]}
                  >
                    <CompanyAutocomplete
                      onChange={(companyId) => {
                        this.setState({ excelCompanyId: companyId.value });
                        // this.formRef.current.setFieldsValues({excelFile:undefined})
                      }}
                      style={{ width: 300 }}
                    />
                  </Form.Item>
                )}

                <Form.Item
                  name="excelFile"
                  // className="label-seprator"

                  className="uploadFile"
                  // label="Excel File"
                  label={this.context.translate("_EXCEL_FILE_")}
                  rules={[{ required: true }]}
                >
                  <Upload
                    // beforeUpload={(file) => this.validateFile(file)}
                    onRemove={() =>
                      this.setState({ excelFile: "", fileList: [] })
                    }
                    name="excelFile"
                    action={
                      config.baseURL + "/index.php?c=company&a=fileupload"
                    }
                    listType="text"
                    data={{
                      fileType: "accountimport",
                      fieldName: "excelFile",
                    }}
                    onChange={this.getUploadData}
                    // beforeUpload={(file) => this.validateFile(file)}
                    maxCount={1}
                  >
                    <Button icon={<UploadOutlined />}>
                      {this.context.translate("_CLICKTOUPLOAD_EXCELFILE_")}
                    </Button>
                  </Upload>
                </Form.Item>

                <div className="formBtnGroup">
                  <Button
                    className="formCancelButton"
                    // style={{ backgroundColor: config.activeColor }}
                    onClick={() => this.maitenanceStore.sampleExcel()}
                  >
                    {this.context.translate("_SAMPLE_")}
                  </Button>
                  <Button
                    type="primary"
                    className="formSaveButton"
                    htmlType="submit"
                    // loading={this.state.loading}
                  >
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </div>
              </Form>
            </Modal>{" "}
          </>
        )} */}

        {this.state.showUpload && (
          <>
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.showUpload}
              placement={
                this.context.locale.language === "english" ? "right" : "left"
              }
              footer={false}
              title={
                <div className="uploadExcelTitle">
                  <Image
                    style={{ height: "60px" }}
                    src={UploadTitleIcon}
                  ></Image>
                  <span> {this.context.translate("_UPLOAD_EXCEL_TITLE_")}</span>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ showUpload: false })}
              onCancel={() =>
                this.setState({
                  showUpload: false,
                  excelFile: "",
                  companyId: "",
                })
              }
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelSubmit}
                style={{ margin: "16px 0px" }}
              >
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                  <Form.Item
                    name="companyId"
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_ACCOUNT_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message:
                          "Please select" +
                          " " +
                          this.context.translate("_ACCOUNT_"),
                      },
                    ]}
                    required={false}
                  >
                    <CompanyAutocomplete
                      onChange={(companyId) => {
                        this.setState({ excelCompanyId: companyId.value });
                      }}
                    />
                  </Form.Item>
                )}
                <Dragger
                  onRemove={() =>
                    this.setState({ excelFile: "", fileList: [] })
                  }
                  name="excelFile"
                  action={
                    // config.baseURL + "/index.php?c=company&a=fileupload"
                    config.baseURL + this.maitenanceStore.fileUploadUrl
                  }
                  listType="text"
                  data={{
                    fileType: "accountimport",
                    fieldName: "excelFile",
                  }}
                  onChange={this.getUploadData}
                  maxCount={1}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                    }}
                  >
                    <div>
                      <Image
                        style={{ width: "90px" }}
                        src={uploadOutlined}
                      ></Image>
                    </div>
                    <div className="uploadFileText">
                      <span>
                        {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                      </span>
                      <p>
                        {this.context.translate("_UPLOAD_TEXT_")}{" "}
                        <span
                          style={{
                            color: "var(--Blue-6, #1890FF)",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                        </span>
                        {this.context.translate("_UPLOAD_TEXT_2_")}
                      </p>
                    </div>
                  </div>
                </Dragger>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    textAlign: "center",
                    marginTop: "16px",
                  }}
                >
                  <div className="sampleDownload">
                    <span> {this.context.translate("_SAMPLE_DOWNLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                    <Button onClick={() => this.maitenanceStore.sampleExcel()}>
                      <Image src={sampleDownloadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {" "}
                        {this.context.translate("_SAMPLE_DOWNLOAD_")}
                      </span>
                    </Button>
                  </div>

                  <div className="sampleUpload">
                    <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                    <Button>
                      <Image src={sampleUploadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {this.context.translate("_SAMPLE_UPLOAD_")}
                      </span>{" "}
                    </Button>
                  </div>
                </div>

                <Space className="uploadFooter">
                  <Button
                    className="uploadCancelButton"
                    onClick={() =>
                      this.setState({
                        showUpload: false,
                        excelFile: "",
                        companyId: "",
                      })
                    }
                  >
                    {this.context.translate(
                      "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                    )}
                  </Button>
                  <Button
                    htmlType="submit"
                    className="uploadButton"
                    // onClick={() => this.onExcelSubmit()}
                  >
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </Space>
              </Form>
            </Drawer>{" "}
          </>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleMaintenanceList.contextType = StoreContext;
export default observer(withRouter(VehicleMaintenanceList));
